import React from "react";
import styled from "styled-components";
import { useIntl } from "react-intl";
import { useGhostSettings } from "app/settings";
import InternalLink from "components/InternalLink";

const FooterWrapper = styled.footer`
    position: relative;
    margin: max(12vmin, 64px) 0 0;
    padding: 48px max(4vmin, 20px) 140px;
    color: #fff;
    background: #0a0b0c;
    a {
        color: hsla(0, 0%, 100%, 0.7);
        &:hover {
            color: #fff;
            text-decoration: none;
        }
    }
`;

const InnerFooterWrapper = styled.div`
    margin: 0 auto;
    max-width: 1200px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    color: hsla(0, 0%, 100%, 0.7);
    font-size: 1.3rem;
    @media (max-width: 767px) {
        display: grid;
        max-width: 500px;
        grid-template-columns: 1fr;
        grid-gap: 0;
        text-align: center;
    }
`;

const Copyright = styled.section`
    margin: 0;
    padding: 0;
    border: 0;
    font: inherit;
    font-size: 100%;
    vertical-align: baseline;
    a {
        color: #fff;
        letter-spacing: -0.015em;
        font-weight: 500;
    }
    @media (max-width: 767px) {
        color: #fff;
        font-size: 1.5rem;
        margin-bottom: 16px;
    }
`;

const Footer = () => {
    const site = useGhostSettings();
    const intl = useIntl();

    return (
        <div className="viewport-bottom">
            <FooterWrapper>
                <InnerFooterWrapper>
                    <Copyright>
                        <InternalLink to="/">{site.title}</InternalLink>
                        {` © 2022`}
                    </Copyright>
                    <div>
                        <a
                            href="https://ghost.org/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {`${intl.formatMessage({
                                id: "Powered by",
                            })} Ghost`}
                        </a>
                    </div>
                </InnerFooterWrapper>
            </FooterWrapper>
        </div>
    );
};

Footer.propTypes = {};

export default Footer;
